<template>
    <div class="container-fluid">
  
      <div class="container-fluid" >
        <div class="d-flex justify-content-center">      
          <q-linear-progress v-if="!chartLoaded" color="primary" indeterminate />

          <q-btn v-else outline class="q-mb-md" no-caps color="green" label="Export Raw Data as CSV"
                    v-on:click="getActivityExportCSV()" />
        </div>
  
        <div class="graph-container">
          <div class="graph-chart large-graph">
            <Bar v-if="chartLoaded && referralChartData" v-bind:chartData="this.referralChartData"
              v-bind:chartOptions="referralChartOptions" />
          </div>

          <div class="graph-chart large-graph">
            <Bar v-if="chartLoaded && dischargeChartData" v-bind:chartData="this.dischargeChartData"
              v-bind:chartOptions="dischargeChartOptions" />
          </div>

          <div class="graph-chart medium-graph">
              <Pie v-if="chartLoaded && interactionChartData" v-bind:chartData="this.interactionChartData"
              v-bind:chartOptions="interactionChartOptions" />
          </div>

          <div class="graph-chart medium-graph">
            <Pie v-if="chartLoaded && groupHoursEngagedChartData" v-bind:chartData="this.groupHoursEngagedChartData"
              v-bind:chartOptions="groupHoursEngagedChartOptions" />
          </div>
          
          <div class="graph-chart medium-graph">
              <Pie v-if="chartLoaded && individualEngagedChartData" v-bind:chartData="this.individualEngagedChartData"
              v-bind:chartOptions="individualEngagedChartOptions" />
          </div>

        </div>
      </div>
      <q-inner-loading
          :showing="visible"
          label="Please wait..."
          label-class="text-teal"
          label-style="font-size: 1.1em"
        />
    </div>
  
  </template>
  
  <script>
  
  import api from "../../services/api/api"
  
  import Pie from "../ChartComponents/Pie.vue"
  import Bar from "../ChartComponents/Bar.vue"
  import notify from '@/services/util/notify';
  import { retPieOptions, retLineOptions } from "../DataComponents/chartOptions";

  export default ({
    name: 'ClientActivity',
    components: { Pie, Bar},
    props: ['query'],
  
    data() {
      return {
        formattedActivity: {},

        iwiData: null,
        selectedIwi: null,
  
        chartLoaded: false,

        referralChartData: null,
        dischargeChartData: null,
        engagedChartData: null,
        interactionChartData: null,
        clientIssuesChartData: null, 

        referralChartOptions: retLineOptions("Top 10 Referral Sources of All Time", "y", "Value", "Referral Source", "Num. of Clients"),
        dischargeChartOptions: retLineOptions("Top 10 Discharge Reasons of All Time", "y", "Value", "Discharge Reason", "Num. of Clients"),
        groupHoursEngagedChartOptions: retPieOptions("Hours Spent Engaged via Groups", "Hours Engaged"),
        individualEngagedChartOptions: retPieOptions("Hours Spent Engaged via 1 on 1", "Hours Engaged"),
        interactionChartOptions: retPieOptions("Time Since Last Interaction", "Category"),

        visible: false,
  
        waitlistData: null,
        waitlistColumns: [
          { name: 'name', align: 'left', label: 'Name', field: row => row.first_name + ' ' + row.last_name, sortable: true },  
          { name: 'gender', align: 'left', label: 'Gender', field: 'gender_id', sortable: true },
          { name: 'age_range', align: 'left', label: 'Age Range', field: 'age_range_id', sortable: true },
          { name: 'programme', align: 'left', label: 'Programme', field: 'programme_id', sortable: true },
          { name: 'user', align: 'left', label: 'Assigned Staff', field: 'user_id', sortable: true },
          { name: 'days_elapsed', align: 'left', label: 'Days Elapsed', field: 'days_elapsed', sortable: true },
        ],
      }
    },
  
  
    created() {
      this.onIntialize();
    },
  
    methods: {
  
      /**
       * Set all the required chart data and chart options.
       */
      onIntialize() {
  
        // Fetch all client data from backend. Returns list of data once all requests have completed
        const fetchData = function (query) {
          return Promise.all([
            api.clientGraph.clientGroupEngaged(query).catch(error => ({ error })),
            api.clientGraph.clientIndividualEngagement(query).catch(error => ({ error })),
            api.clientGraph.clientReferral(query).catch(error => ({ error })),
            api.clientGraph.clientDischarge(query).catch(error => ({ error })),
            api.clientGraph.clientInteraction(query).catch(error => ({ error })),
          ])
        }
  
        fetchData(this.query).then((values) => {
          // Filter out the errors
          const chartData = values.map(value => value.error ? null : value.data);
          
          this.groupHoursEngagedChartData = chartData[0];
          this.individualEngagedChartData = chartData[1];
          this.referralChartData = chartData[2];
          this.dischargeChartData = chartData[3];
          this.interactionChartData = chartData[4];
  
          this.$emit("displayErrors", values);

        }).catch(() => {
            notify.error("Error retrieving client activity data", 'top');
        }).finally(() => {
          this.chartLoaded = true;
      });
    },
  
    /**
     * @desc Retrieves client demographic information as a CSV file
     */
    getActivityExportCSV(){
      api.client.getClientActivityCSVExport(this.formattedActivity).then(() => {
        notify.primary("Successfully download CSV file!", "top")
      }).catch(err => {
          console.error(err);
          notify.error("There was an error downloading the CSV file.", "top");
      })
    }
  },
})


</script>

<style scoped>
@import '../../assets/styles/clientDemographics.css';
</style>